import React from 'react';
import PropTypes from 'prop-types';

import Filter from './filter';
import PropertyTypeFilter from './property_type_filter';

export default function CompLeaseFilters({ query, onChange }) {
  return <React.Fragment>
    <Filter
      className="form-select"
      label="On market or leased"
      name="onMarketEq"
      query={query}
      type="select"
      onChange={onChange}
    >
      <option value="">Both</option>
      <option value="true">On market</option>
      <option value="false">Leased</option>
    </Filter>

    <PropertyTypeFilter query={query} onChange={onChange} />

    <Filter
      label="Lease rate ($/month)"
      name="totalNormalizedLeaseRate"
      query={query}
      range
      unitLabel="$"
      onChange={onChange}
    />

    <Filter
      label="Building Size (SF)"
      name="researchPropertyBuildingSize"
      query={query}
      range
      unitLabel="SF"
      onChange={onChange}
    />

    <Filter
      label="Lot Size (Acres)"
      name="researchPropertyLotSize"
      query={query}
      range
      unitLabel="AC"
      onChange={onChange}
    />

    <Filter
      label="Leased Space (SF)"
      name="size"
      query={query}
      range
      unitLabel="SF"
      onChange={onChange}
    />
  </React.Fragment>;
}

CompLeaseFilters.propTypes = {
  query: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
